export const businessDayAdjustmentList = [
  { name: "Preceding", value: "a8e64472-766b-11e9-87b9-0242ac120002" },
  { name: "Modified Preceding", value: "c21f8281-766b-11e9-87b9-0242ac120002" },
  { name: "Following", value: "ccbe03f8-766b-11e9-87b9-0242ac120002" },
  { name: "Modified Following", value: "d429791f-766b-11e9-87b9-0242ac120002" }
];
export default {
  PRECEDING: "a8e64472-766b-11e9-87b9-0242ac120002",
  MODIFIED_PRECEDING: "c21f8281-766b-11e9-87b9-0242ac120002",
  FOLLOWING: "ccbe03f8-766b-11e9-87b9-0242ac120002",
  MODIFIED_FOLLOWING: "d429791f-766b-11e9-87b9-0242ac120002"
};
